import { createFileRoute } from "@tanstack/react-router";
import { AdminScheduleSettings } from "@/components/admin/AdminScheduleSettings";

export const Route = createFileRoute("/_authenticated/admin/availability")({
  head: () => ({ meta: [{ title: "Availability — Admin" }] }),
  component: AdminAvailabilityPage,
});

function AdminAvailabilityPage() {
  return (
    <section>
      <h2 className="mb-4 font-display text-xl">Hours &amp; open days</h2>
      <AdminScheduleSettings />
    </section>
  );
}
